import { render } from "./Likes.vue?vue&type=template&id=aaab5e74"
import script from "./Likes.vue?vue&type=script&lang=js"
export * from "./Likes.vue?vue&type=script&lang=js"

import "./Likes.vue?vue&type=style&index=0&id=aaab5e74&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__